<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
</script>

<div class="fizz-stack-32 flex items-center justify-center">
  <Icon type="Enroll" width={200} height={200} />
</div>
<h2 class="text-center fizz-stack-32">You’re Verified!</h2>
<p class="fizz-text-subdued fizz-inset-horizontal-16 fizz-stack-32 fizz-text-large text-center">
  You can now access high proof spirits & liquor from:
</p>

<div class="fizz-stack-32">
  <h4 class="text-center fizz-stack-8 fizz-heading-4">
    <p>Vermont Dept. of Liquor and Lottery</p>
  </h4>
</div>

<div class="fizz-stack-32">
  <p class="text-center fizz-text-subdued fizz-text-italic"
    >You may be asked for your Third Class License prior to placing an order.</p
  >
</div>
